module.exports = __webpack_public_path__ + "static/media/close-white.639cb8d4.svg";